import { render, staticRenderFns } from "./callAssistance.vue?vue&type=template&id=a6ee9bae&scoped=true&"
import script from "./callAssistance.vue?vue&type=script&lang=js&"
export * from "./callAssistance.vue?vue&type=script&lang=js&"
import style0 from "./callAssistance.vue?vue&type=style&index=0&id=a6ee9bae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6ee9bae",
  null
  
)

export default component.exports